// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"8c570aa6","492":"eb341993","898":"d7efa190"}[chunkId] + ".chunk.js";
};